import React from 'react';
import { Form, Row } from 'reactstrap';
import { CustomForm } from 'components/Generic/CustomForm';
import { useForm } from 'react-hook-form';
import { Text } from 'components/Form/Fields';
import { TYPE_PRODUCTS } from 'utility/data-offiline';
import { Checkbox } from 'components/Form/Fields';
import { useMediaQuery } from 'react-responsive';
import { Select } from 'components/Form/Fields';

const toRedirect = '/admin/product/';

export const FormProduct = () => {
  const { reset, getValues, control, setValue, watch } = useForm({
    defaultValues: {
      id: null,
      name: '',
      value: 0,
      type: '',
      quantity: 0,
      enable: true,
    },
  });

  const isMobileDevice = useMediaQuery({
    query: '(max-width: 990px)',
  });

  const handleCheckbox = () => {
    return isMobileDevice ? { marginLeft: '20px' } : { marginLeft: '30px' };
  };

  return (
    <>
      <CustomForm
        nameForm={'Cadastro de Produto'}
        typeForm={'POST'}
        pathUrl={'/v1/product'}
        toRedirect={toRedirect}
        getValues={getValues}
        loadValues={reset}
        forceRefreshPage
      >
        <Form>
          <div className='pl-lg-4'>
            <Row>
              <Text
                control={control}
                label={'Nome do Produto'}
                fieldName={'name'}
                placeholder={'Informe o nome do produto'}
                size={3}
              />
              <Text
                control={control}
                fieldName={'value'}
                label={'Valor'}
                placeholder={'Informe o valor do produto'}
                size={3}
              />
              <Select
                control={control}
                fieldName={'type'}
                label={'Selecione o tipo'}
                size={2}
                data={TYPE_PRODUCTS}
              />
            </Row>

            <Row>
              <Text
                control={control}
                fieldName={'quantity'}
                label={'Quantidade'}
                placeholder={'Informe o estoque do produto'}
                size={3}
              />
              <Checkbox
                style={handleCheckbox()}
                setValue={setValue}
                getValues={getValues}
                watch={watch}
                field='enable'
                textEnable='Habilitado'
                textDisable='Desabilitado'
                size={2}
              />
            </Row>
          </div>
        </Form>
      </CustomForm>
    </>
  );
};
